module.exports = "<div id=\"player\"></div>\n"